import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LoadingService } from '../shared/services/loading.service';
import { NewsletterFormContent } from '../models/tenant.model';
import { NewsletterComponent } from '../newsletter/newsletter.component';
import { LoadingComponent } from '../shared/loading/loading.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'newsletter-dialog',
  templateUrl: './newsletter-dialog.component.html',
  styleUrls: ['./newsletter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LoadingService],
  imports: [MatIconModule, LoadingComponent, MatDialogModule, NewsletterComponent]
})
export class NewsletterDialogComponent {
  private dialogRef = inject<MatDialogRef<NewsletterDialogComponent>>(MatDialogRef);
  readonly newsletterContent = inject<NewsletterFormContent>(MAT_DIALOG_DATA);

  close() {
    this.dialogRef.close();
  }
}
